import React from 'react'
import ProjectReportTab from './components/peojectReportTab'
import SaveReportTab from './components/saveReportTab'

const ProjectReport = () => {
    return (
        <div>
            <div
                className="container"
                style={{
                    zIndex: 10,
                    minHeight: "100vh",
                    padding: "35px",
                    borderRadius: "0px",
                }}
            >

                <SaveReportTab />
            </div>
        </div>
    )
}

export default ProjectReport
